import { FieldNumberOutlined } from '@ant-design/icons';
import { Form, Input } from "antd";
import { Permission } from "../../apis/mgmt/api";
import { DataForm } from "../common/DataForm";
import { DataViewProps } from "../common/DataView";
import { DomainFormItem, DomainSelect } from '../domain/DomainSelect';
import { UserSearchSelect } from '../user/UserSearchSelect';
import { RoleSelect } from './RoleSelect';


export const PermissionForm = function (
    props: DataViewProps<Permission>
) {
    
    return (
        <DataForm {...props}>
            {/* id */}
            <Form.Item
                className="input"
                name="id"
            >
                <Input prefix={<FieldNumberOutlined className="site-form-item-icon" />} placeholder="ID" disabled={true} />
            </Form.Item>

            {/* user */}
            <Form.Item
                className="input"
                name={['user', 'id']}
                rules={[{ required: true, message: '¡Please input the Username!' }]}
            >
                <UserSearchSelect selected={props.data?.user} />
            </Form.Item>

            {/* domain */}
            <DomainFormItem
                name={["role", "domain" ]}
                rules={[{ required: true, message: '¡Please select the domain!' }]}
            >
                <DomainSelect />
            </DomainFormItem>

            {/* role */}
            <Form.Item
                className="input"
                name={['role', 'level']}
                rules={[{ required: true, message: '¡Please input your Role!' }]}
            >
                <RoleSelect domainId={props.data?.role?.domain?.id} />
            </Form.Item>

        </DataForm>
    );

};
